module.exports = __webpack_public_path__ + "static/media/51.db2a7ff7.jpg";